import { Injectable } from '@angular/core';
import { SimuladorApi } from '@gestor-web/@core/api/ords';
import { CuboItemPreGerado, JSON_PRE_GERADO_TIPO } from '@gestor-web/@core/api/ords/model';
import { map, Observable } from 'rxjs';

export interface AnalisesData {
  linhas: CuboItemPreGerado[];
  atualizacao: string;
}

@Injectable({
  providedIn: 'root',
})
export class AnalisesService {
  constructor(private simuladorApi: SimuladorApi) {}

  fetchData(consulta: JSON_PRE_GERADO_TIPO, regans: string, anobase: number): Observable<AnalisesData> {
    return this.simuladorApi.fetchDadosJsonPreGerado<CuboItemPreGerado>(regans, consulta, { anobase }).pipe(
      map(response => {
        const { items } = response;
        const { linhas } = items[0] ?? {};
        const atualizacao = items[0]?.dt_atualizacao;

        return {
          linhas,
          atualizacao,
        };
      }),
    );
  }
}
